var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15492_29945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.00016V12.0002M11.9999 16.0002H12.0099M2.69991 10.3002C2.47586 10.524 2.29812 10.7898 2.17685 11.0823C2.05558 11.3749 1.99316 11.6885 1.99316 12.0052C1.99316 12.3219 2.05558 12.6354 2.17685 12.928C2.29812 13.2206 2.47586 13.4863 2.69991 13.7102L10.2899 21.3002C10.5137 21.5242 10.7795 21.702 11.0721 21.8232C11.3646 21.9445 11.6782 22.0069 11.9949 22.0069C12.3116 22.0069 12.6252 21.9445 12.9177 21.8232C13.2103 21.702 13.4761 21.5242 13.6999 21.3002L21.2899 13.7102C21.514 13.4863 21.6917 13.2206 21.813 12.928C21.9342 12.6354 21.9967 12.3219 21.9967 12.0052C21.9967 11.6885 21.9342 11.3749 21.813 11.0823C21.6917 10.7898 21.514 10.524 21.2899 10.3002L13.6999 2.71016C13.4761 2.48611 13.2103 2.30837 12.9177 2.1871C12.6252 2.06584 12.3116 2.00342 11.9949 2.00342C11.6782 2.00342 11.3646 2.06584 11.0721 2.1871C10.7795 2.30837 10.5137 2.48611 10.2899 2.71016L2.69991 10.3002Z",
    stroke: "#CC3011",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15492_29945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.b7ed8e56e10c18c0211567510eb3d175.svg";
export { ForwardRef as ReactComponent };